import React from 'react';
import useFetchApi from '../../hooks/useFetchApi';

import { FRONTEND_FAQ_URL } from '../../utils/Constant';

function Faq() {

    const { data, loading, error } = useFetchApi({
        url: FRONTEND_FAQ_URL,
        dataKey: 'faqs',
    });


    if (loading) {
        return (
            <section className="bg-[#f5f5f5] py-16 overflow-hidden mt-20">
                <div className="container mx-auto px-4">
                    <p className="text-center">
                        Loading FAQs...
                    </p>
                </div>
            </section>
        );
    }


    if (error) {
        return (
            <section className="bg-[#f5f5f5] py-16 overflow-hidden mt-20">
                <div className="container mx-auto px-4">
                    <p className="text-center text-red-500">
                        {error}
                    </p>
                </div>
            </section>
        );
    }


    return (
        <section className="bg-[#f5f5f5] py-16 overflow-hidden mt-20">

            <div className="container mx-auto px-4">

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                    {/* Left Image */}

                    <div className="relative">

                        <div
                            className="
                                absolute
                                -left-40
                                top-10
                                w-72
                                h-72
                                bg-blue-100
                                rounded-full
                                opacity-70
                            "
                        />

                        <div
                            className="
                                absolute
                                -left-20
                                bottom-0
                                w-40
                                h-40
                                bg-blue-600
                                rounded-full
                            "
                        />

                    </div>


                    {/* Right Content */}

                    <div>

                        <h2
                            className="
                                text-5xl
                                font-bold
                                text-black
                                mb-4
                            "
                        >
                            FAQs
                        </h2>


                        <p
                            className="
                                text-gray-700
                                text-lg
                                leading-8
                                mb-8
                            "
                        >
                            In order to help you we resolve some issues,
                            Our team have already answered the most common ones.
                        </p>


                        <div className="space-y-5">

                            {data.map((item, index) => (

                                <div
                                    key={item.id}
                                    className="
                                        collapse
                                        collapse-plus
                                        bg-white
                                        border
                                        border-gray-200
                                        rounded-none
                                        shadow-sm
                                    "
                                >

                                    <input
                                        type="radio"
                                        name="faq-accordion"
                                        defaultChecked={index === 0}
                                    />


                                    <div
                                        className="
                                            collapse-title
                                            text-lg
                                            font-semibold
                                            text-black
                                            pr-14
                                        "
                                    >
                                        {item.question}
                                    </div>


                                    <div
                                        className="
                                            collapse-content
                                            text-gray-700
                                            leading-8
                                        "
                                    >

                                        <p>
                                            {item.answer}
                                        </p>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default Faq;